import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CapitalizeFirstPipe } from '../../pipes/capitalizefirst.pipe';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrl: './confirmation-popup.component.scss',
  imports: [CommonModule, CapitalizeFirstPipe],
})
export class ConfirmationPopupComponent {
  @Input() public name: any;
  @Input() public actionType: any;
  @Input() public confirmationMessage: any;
  constructor(
    private readonly _activeModal: NgbActiveModal,
    private readonly _modalConfig: NgbModalConfig,
  ) {
    this._modalConfig.centered = true;
  }

  onNegativeClick() {
    this.restoreTriggerFocus();
    this._activeModal.close();
  }

  onPositiveClick() {
    this.restoreTriggerFocus();
    this._activeModal.close(true);
  }
  private restoreTriggerFocus() {
    // Look for the element that opened the modal (give it a data attribute)
    const triggerEl = document.querySelector('[data-modal-trigger]') as HTMLElement;
    if (triggerEl) {
      triggerEl.focus();
    }
  }
}
